var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2499 8.33337C20.9758 8.33337 22.3749 6.93426 22.3749 5.20837C22.3749 3.48248 20.9758 2.08337 19.2499 2.08337C17.524 2.08337 16.1249 3.48248 16.1249 5.20837C16.1249 6.93426 17.524 8.33337 19.2499 8.33337Z",
    stroke: "white",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74994 15.625C8.47583 15.625 9.87494 14.2259 9.87494 12.5C9.87494 10.7741 8.47583 9.375 6.74994 9.375C5.02405 9.375 3.62494 10.7741 3.62494 12.5C3.62494 14.2259 5.02405 15.625 6.74994 15.625Z",
    stroke: "white",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2499 22.9166C20.9758 22.9166 22.3749 21.5175 22.3749 19.7916C22.3749 18.0657 20.9758 16.6666 19.2499 16.6666C17.524 16.6666 16.1249 18.0657 16.1249 19.7916C16.1249 21.5175 17.524 22.9166 19.2499 22.9166Z",
    stroke: "white",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44769 14.0729L16.5623 18.2187",
    stroke: "white",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5519 6.78125L9.44769 10.9271",
    stroke: "white",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareHover);
export default __webpack_public_path__ + "static/media/shareHover.413f5012c19f2b6bed86d918bb7106eb.svg";
export { ForwardRef as ReactComponent };